import type { AppLocale } from "@metaadsmanager/tk-master-contracts";

/** Map app locale codes to Intl / React Aria locale tags. */
export const formatLocale = (locale: AppLocale | string): string =>
  locale === "zh-CN" || locale.startsWith("zh") ? "zh-CN" : "en-US";
